
import type { CSSProperties } from 'react';
import clsx from 'clsx';
interface ProgressProps {
  progress: number;
  className?: string;
  barClassName?: string;
  trackClassName?: string;
  progressBarStyle?: CSSProperties;
}

const Progress = ({ progress, className, barClassName, trackClassName, progressBarStyle }: ProgressProps) => {
  return (
    <div className={clsx("w-full h-[5px] flex items-center relative", className)}>
      <div className={clsx('absolute top-0 left-0 w-full h-full rounded-full bg-[rgba(0,0,0,0.35)] overflow-hidden flex', trackClassName)}>
        <div
          className={clsx("absolute left-0 top-0 h-full flex items-center rounded-full transition duration-150", barClassName)}
          style={{ width: `${progress}%`, ...progressBarStyle }} // 700/1000 = 70%
        />
        {/* <div className="relative z-10 flex items-center justify-center h-full w-full text-white text-[10px] font-medium">{progress}%</div> */}
      </div>
    </div>
  );
};

export default Progress;